const pkg = require('../../package.json');

export const HEADER_STORE_CODE = 'X-STORE-CODE';


// Default configuration
export let config = {
    mock: false,
    noPolling: false,
    // application_name: process.env.npm_package_name,
    application_name: pkg.name,
    application_version: pkg.version,
    application_revision: process.env.APP_REVISION,
    features: {
        FEATURE_GOOGLE_DIRECTIONS: false,
    }
}


if (window.location && "deliverytracker-web.staging.uq-systems.net" === window.location.host) {
    console.log("Detected Staging Environment");
    Object.assign(config, {
        brokerURL: 'wss://deliverytracker-api.staging.uq-systems.net/websocket',
        homeUrl: 'https://deliverytracker-api.staging.uq-systems.net/login?return_url=https://deliverytracker-web.staging.uq-systems.net',
        apiUrl: 'https://deliverytracker-api.staging.uq-systems.net',
        googleMapsKey: 'AIzaSyACSTziajqv24WVnHxi7F9Ws8b5q-nAnnQ',
    });

} else if (window.location && "deliverytracker-web.production.uq-systems.net" === window.location.host) {
    console.log("Detected Production Environment");
    Object.assign(config, {
        // production
        brokerURL: 'wss://deliverytracker-api.production.uq-systems.net/websocket',
        homeUrl: 'http://192.168.86.112/GOAL',
        apiUrl: 'https://deliverytracker-api.production.uq-systems.net',
        googleMapsKey: 'AIzaSyCYc6ShCeHzO4hHINQChwSomCKcU3NN-LQ',
    });

} else {
    console.log("Using Local Environment");
    Object.assign(config, {
        // Local
        mock: true,
        // brokerURL: 'ws://localhost:8090/websocket',
        // homeUrl: 'http://localhost:8090/login?return_url=http://localhost:9090',
        // apiUrl: 'http://localhost:8090',

        // local with production server, add a storeCode in websocket file, turn mock var to false
        // brokerURL: 'wss://deliverytracker-prod-api.factsandit.mindera.com/websocket',
        // homeUrl: 'https://deliverytracker-prod-api.factsandit.mindera.com/login?return_url=http://localhost:9000',
        // apiUrl: 'https://deliverytracker-prod-api.factsandit.mindera.com',

        // local with staggin server, add a storeCode(ex: 248) in websocket file, turn mock var to false
        brokerURL: 'wss://deliverytracker-api.staging.uq-systems.net/websocket',
        homeUrl: 'https://deliverytracker-api.staging.uq-systems.net/login?return_url=https://deliverytracker-web.staging.uq-systems.net',
        apiUrl: 'https://deliverytracker-api.staging.uq-systems.net',

        googleMapsKey: 'AIzaSyACSTziajqv24WVnHxi7F9Ws8b5q-nAnnQ',
    });
}

export default config;